/**
 * @ngdoc function
 * @name cimerFrontEndApp.controller:DocumentListCtrl
 * @description
 * # DocumentListCtrl
 * Controller of the cimerFrontEndApp
 */

angular.module('cimerFrontEndApp').controller('DocumentListCtrl', ['$scope', '$location', '$uibModal', '$http', 'Session', 'DocumentService', 'ApiUrl', function ($scope, $location, $uibModal, $http, Session, DocumentService, ApiUrl) {
    'use strict';
    var sessionObject = Session.getSessionObject();
    if (!sessionObject.isAuthenticated || !(sessionObject.isAdmin || sessionObject.isCurriculaAdmin)) {
        $location.url('/');
        return;
    }

    // Sorting variables
    $scope.sortPropertyName = '';
    $scope.sortReverse = true;

    // Filtering variables
    $scope.searchQuery = '';
    $scope.filterTypes = [];
    $scope.filterTags = [];

    //Get the list of Documents
    DocumentService.getAllDocuments().then(function (result) {
        $scope.DocumentList = result.data;
    }, function () {
        $scope.DocumentList = null;
        });

    DocumentService.getAllDocumentTags().then(function (result) {
        var tags = result.data;
        $scope.DocumentTags = tags.sort(function (a, b) {
            return a.Description > b.Description ? 1 : -1;
        });
    }, function () {
        $scope.DocumentTags = null;
    });

    DocumentService.getDocumentTypes().then(function (result) {
        $scope.DocumentTypes = result.data;
    }, function () {
        $scope.DocumentTypes = null;
    });

    $scope.filter = function () {
        if ($scope.searchQuery === undefined || $scope.searchQuery === "") {
            // Return the whole list
            $scope.filterData = function (doc) { return true; };
        }

        $scope.filterData = {};
        $scope.filterData['Title'] = $scope.searchQuery;

    };

    $scope.toggleType = function (type) {
        if ($scope.filterTypes.indexOf(type) === -1) {
            $scope.filterTypes.push(type);
        }
        else {
            var i = $scope.filterTypes.indexOf(type);
            $scope.filterTypes.splice(i, 1);
        }
    };

    $scope.toggleTag = function (tag) {
        if ($scope.filterTags.indexOf(tag) === -1) {
            $scope.filterTags.push(tag);
        }
        else {
            var i = $scope.filterTags.indexOf(tag);
            $scope.filterTags.splice(i, 1);
        }
    };

    $scope.typeFilter = function (doc) {
        if ($scope.filterTypes.length === undefined || $scope.filterTypes.length === 0) { return true; }
        for (var i = 0; i < $scope.filterTypes.length; i++) {
            if (doc.DocumentType.Text === $scope.filterTypes[i].Text) {
                return true;
            }
        }
    };

    $scope.tagFilter = function (doc) {
        if ($scope.filterTags.length === undefined || $scope.filterTags.length === 0) { return true; }
        for (var i = 0; i < $scope.filterTags.length; i++) {
            if (doc.DocumentTagList.indexOf($scope.filterTags[i].Description) > -1) {
                return true;
            }
        }
    };

    $scope.addDocument = function () {
        $location.url('/uploadDocument');
    };

    $scope.redirectToEdit = function (docId) {
        $location.url('/editDocument/' + docId);
    };

    $scope.sortBy = function (sortPropertyName) {
        $scope.sortReverse = ($scope.sortPropertyName === sortPropertyName) ? !$scope.sortReverse : false;
        $scope.sortPropertyName = sortPropertyName;
    };

    $scope.setDocumentActiveState = function (doc) {
        var _toggleactiveapiUrl = ApiUrl.url('/Document/');
        var closeModal = $uibModal.open({
            animation: true,
            templateUrl: 'toggleActive.html',
            controller: 'toggleActiveCtrl',
            resolve: {
                docName: function () {
                    return doc.Title;
                }
            }
        });
        closeModal.result.then(function (accepted) {
            var data = {
                DocumentID: doc.DocumentID,
                Active: !doc.Active
            };
            if (accepted) {
                $http.post(_toggleactiveapiUrl + 'SetDocumentActiveState', data).then(function (response) {
                    doc.Active = !doc.Active;
                });
            }
        },
            function () {
                // Handle dismissing the pop-up
            }
        );
    };

    $('.collapse').on('show.bs.collapse', function () {
        $(this).parent('.panel').find('.fa-minus').show();
        $(this).parent('.panel').find('.fa-plus').hide();
    });
    $('.collapse').on('hide.bs.collapse', function () {
        $(this).parent('.panel').find('.fa-minus').hide();
        $(this).parent('.panel').find('.fa-plus').show();
    });
}])
.controller('toggleActiveCtrl', ['$scope', '$uibModalInstance', 'docName', function ($scope, $uibModalInstance, docName) {
    'use strict';
    $scope.docName = docName;

    $scope.accept = function () {
        $uibModalInstance.close(true);
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
}]);
